import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: "app-reasignar-responsable",
  standalone: true,
  templateUrl: "./reasignar-responsable.component.html",
  styleUrls: ["./reasignar-responsable.component.css"],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    MatOption,
    MatButton,
    MatIconButton,
    MatIcon,
  ],
})
export class ReasignarResponsableComponent implements OnInit {
  form = new FormGroup({
    selectedEmpleado: new FormControl<number | null>(null, Validators.required),
    motivo: new FormControl("", Validators.required),
  });

  constructor(
    public dialogRef: MatDialogRef<ReasignarResponsableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.form.patchValue({
      selectedEmpleado: this.data?.selectedEmpleado ?? null,
      motivo: this.data?.motivo ?? "",
    });
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      selectedEmpleado: Number(this.form.value.selectedEmpleado),
      motivo: String(this.form.value.motivo || "").trim(),
    });
  }
}
